import { Box, Divider, Typography } from '@mui/material';
import { FC } from 'react';

interface Props {
  text?: string;
}

export const QcsDivider: FC<Props> = ({ text }) => {
  if (!text) {
    return <Divider />;
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center', color: '#999', fontSize: 12, fontWeight: 600, my: 2 }}>
      <Divider sx={{ flex: 1 }} />
      <Typography sx={{ px: 2, color: '#999', fontSize: 12, fontWeight: 600 }}>
        {text}
      </Typography>
      <Divider sx={{ flex: 1 }} />
    </Box>
  );
};